// Actions
export const TRACKING_API_RESPONSE_SUCCESS = "TRACKING_API_RESPONSE_SUCCESS";
export const TRACKING_API_RESPONSE_ERROR = "TRACKING_API_RESPONSE_ERROR";

export const TRACKING_CHECK_SHIPMENT = "TRACKING_CHECK_SHIPMENT";
export const TRACKING_CLEAR_CACHE = "TRACKING_CLEAR_CACHE";
